export default {
  'driver-add': [
    { path: '/driver/list', title: 'Список водителей' },
    { path: '', title: 'Добавление водителя' },
  ],
  'auto-add': [
    { path: '/auto/list', title: 'Автопарк' },
    { path: '', title: 'Добавление авто' },
  ],
  'user-organizations-list': [
    { path: '', title: 'Список организаций пользователя' },
  ],
  'driver-list': [{ path: '', title: 'Список водителей' }],
  'managers-list': [{ path: '', title: 'Список менеджеров' }],
  'manager-add': [
    { path: '/managers', title: 'Список менеджеров' },
    { path: '', title: 'Добавление менеджера' },
  ],
  'contragent-list': [{ path: '', title: 'Список контрагентов' }],
  'auto-list': [{ path: '', title: 'Список авто' }],
  documents: [{ path: '', title: 'Документы' }],
  'shipping-add': [{ path: '', title: 'Создание новой погрузки' }],
  'load-day': [{ path: '', title: 'День погрузки' }],
  users: [{ path: '', title: 'Список пользователей' }],
  flights: [{ path: '', title: 'Список рейсов' }],
  'clients-settings': [{ path: '', title: 'Настройки клиента' }],
  'edm-users': [{ path: '', title: 'Список пользователей ЭДО' }],
  calculator: [{ path: '', title: 'Калькулятор' }],
  'call-center': [{ path: '', title: 'Колл-центр' }],
  'call-center-task': [
    { path: '/call-center', title: 'Колл-центр' },
    { path: '', title: 'Контакты' },
  ],
  'register-of-payments': [{ path: '', title: 'Реестр оплат' }],
  'table-of-payments': [{ path: '', title: 'Таблица платежей' }],
  reports: [{ path: '', title: 'Список отчетов' }],
  'unknown-files': [
    { path: '/documents', title: 'Документы' },
    { path: '', title: 'Работа с файлами из терминалов' },
  ],
  'pole-rf': [{ path: '', title: 'Поле РФ' }],
  'pole-rf-coefficients': [
    { path: '/pole', title: 'Поле РФ' },
    { path: '', title: 'Изменение коэффициентов' },
  ],
}
